import { useCan } from '../auth/AuthProvider';
import { TablePage } from './TablePage';
import { AddAnchorButton } from '../components/AddAnchorButton';

export function AnchorsPage() {
  const canFlag = useCan('item.flagAnchor');
  const empty = canFlag
    ? 'No anchors yet — click ⚓ Add anchor or open any item and flag it.'
    : 'No anchors yet.';
  return (
    <TablePage
      title="Anchors"
      forceAnchorsOnly
      extraColumn="anchorWhy"
      extraToolbarSlot={canFlag ? <AddAnchorButton /> : null}
      emptyStateMessage={empty}
    />
  );
}
